class AddEntry
    constructor: (el) ->
        @.$el = el
        @.$errorEl = @.$el.querySelector '.add-entry__error'
        @.$parentOverlay = @.$el.closest('.overlay')
        @.$submitButton = @.$el.querySelector '.add-entry__submit'
        @.$successEl = @.$el.querySelector '.add-entry__success'
        @.$textEl = @.$el.querySelector '.add-entry__text'
        @.$textInputEl = @.$textEl?.querySelector 'textarea'
        @.$titleEl = @.$el.querySelector '.add-entry__title'
        @.$topicDescriptionEl = @.$el.querySelector '.add-entry__topic-description'
        @.$topicDescriptionInputEl = @.$topicDescriptionEl?.querySelector 'textarea'
        @.$topicSubjectEl = @.$el.querySelector '.add-entry__topic'
        @.$topicSubjectInputEl = @.$topicSubjectEl?.querySelector 'input'

        @.api = @.$el.dataset?.api
        @.apiMethod = @.$el.dataset?.apiMethod ? 'GET'
        @.errorActive = @.$el.classList.contains 'add-entry--error'
        @.forumId = undefined
        @.postId = @.$el.dataset?.postId ? undefined
        @.successActive = @.$el.classList.contains 'add-entry--success'
        @.successRedirect = @.$el.dataset?.successRedirect ? false
        @.topicId = undefined
        @.type = undefined
        @.valid = true

        @.$el.classList.add 'add-entry--bound'

        @.Init()
        return

    Init: ->
        if @.$el.classList.contains 'add-entry--comment'
            @.type = 'comment'
        if @.$el.classList.contains 'add-entry--message'
            @.type = 'message'
        if @.$el.classList.contains 'add-entry--post'
            @.type = 'post'
        if @.$el.classList.contains 'add-entry--post-edit'
            @.type = 'post-edit'
        if @.$el.classList.contains 'add-entry--topic'
            @.type = 'topic'
        window.dispatchEvent new CustomEvent 'add-entry-ready', {
            bubbles: false
            detail: {
                el: self.$el
                type: self.type
            }
        }
        @.InitEvents()
        return

    InitEvents: ->
        self = @
        @.$el.addEventListener 'add-entry-set-forum-id', (e) ->
            forumId = if e.detail?.forumId then parseInt(e.detail.forumId,10) else false
            if typeof forumId == 'number'
                self.forumId = forumId
            return
        @.$el.addEventListener 'add-entry-set-topic-id', (e) ->
            topicId = if e.detail?.topicId then parseInt(e.detail.topicId,10) else false
            if typeof topicId == 'number'
                self.topicId = topicId
            return
        @.$el.addEventListener 'add-entry-receive-quote', (e) ->
            quotedUser = e.detail?.quotedUser ? false
            quoteText = e.detail?.quoteText ? ""
            self.$textEl.dispatchEvent new CustomEvent 'textarea-receive-quote', {
                bubbles: false
                detail: {
                    quotedUser: quotedUser
                    quoteText: quoteText
                }
            }
            return
        @.$el.addEventListener 'add-entry-error', (e) ->
            errorMessage = e.detail?.errorMessage ? false
            self.SetErrorMessage errorMessage
            return
        @.$el.addEventListener 'add-entry-success', (e) ->
            successMessage = e.detail?.successMessage ? false
            self.SetSuccessMessage successMessage
            return
        @.$el.addEventListener 'add-entry-set-title', (e) ->
            title = e.detail?.title ? false
            if title && title != ""
                if self.$titleEl
                    self.$titleEl.innerHTML = title
                else
                    @.$el.querySelector '.add-entry__head'
                        .prepend window.CreateHeadline {
                            attrs: {
                                class: ['add-entry__title']
                            },
                            level:3,
                            size:3,
                            text: title
                        }
            return
        @.$el.addEventListener 'add-entry-set-api', (e) ->
            api = e.detail?.api ? false
            if api && api != ""
                self.api = api
                self.$el.dataset.api = api
            return
        @.$el.addEventListener 'add-entry-set-text-input', (e) ->
            text = e.detail?.text ? false
            postId = e.detail?.postId ? false
            if text && text != ""
                self.$textInputEl.value = text
            if postId
                self.postId = postId
            return
        @.$submitButton.addEventListener 'click', (e) ->
            e.preventDefault()
            self.Validate()
            if !self.errorActive && !self.successActive && self.valid
                self.SendData()
            return
        return
    
    ScriptTagReplacement: (text) ->
        text = text.replace /<script[\s\S]*?>[\s\S]*?<\/script>/gi, ''
        return text
    
    SendData: ->
        if (@.apiMethod == 'GET' || @.apiMethod == 'POST') && @.api
            self = @
            try
                if @.apiMethod == 'POST'
                    if @.type == 'post' && typeof @.topicId != 'undefined' && @.$textInputEl
                        quoteEl = self.$textEl.querySelector('.textarea__quote-full')
                        if quoteEl
                            text = "[quote=#{ quoteEl.dataset?.quotedUser ? "" }]#{ quoteEl.innerHTML }[/quote] #{ @.$textInputEl.value }"
                        else
                            text = @.$textInputEl.value
                        text = @.ScriptTagReplacement text
                        body = {
                            text: text
                            topic: @.topicId
                        }
                    
                    if @.type == 'post-edit' && typeof @.postId != 'undefined' && @.$textInputEl
                        text = @.$textInputEl.value
                        text = @.ScriptTagReplacement text
                        body = {
                            post: @.postId
                            text: text
                        }

                    if @.type == 'topic' && typeof @.forumId != 'undefined' && @.$topicDescriptionInputEl && @.$topicSubjectInputEl
                        description = if @.$topicDescriptionInputEl.value != "" then @.$topicDescriptionInputEl.value else null
                        subject = @.$topicSubjectInputEl.value
                        text = @.$textInputEl.value
                        body = {
                            description: description
                            forum: self.forumId
                            subject: subject
                            text: text
                        }
                request = window.appUtils.XMLHttpRequest @.apiMethod, @.api
                    , ->
                        if request.responseText && request.responseText != ""
                            try
                                response = JSON.parse request.responseText
                                if response.success
                                    self.SetSuccessMessage response.message
                                    topicRedirect = if self.type == "topic" then response.returnObject.topic else false
                                    self.SetRedirectAction topicRedirect
                                if response.error
                                    self.SetErrorMessage response.message
                            catch error
                                console.log "Beim Versuch Daten zu senden trat ein Fehler auf", error
                                return
                        else
                            console.log "Die Antwort der Schnittstelle auf die gesendeten Daten war leer oder blieb aus."
                            self.SetErrorMessage "Es trat leider ein Fehler auf. Es konnten eventuell nicht alle Daten gespeichert werden.", true
                            self.SetRedirectAction()
                    , ->
                        console.log "Bei der Anfrage an die Schnittstelle ist leider ein Fehler aufgetreten"
                        self.SetErrorMessage "Es trat leider ein Fehler auf. Es konnten eventuell nicht alle Daten gespeichert werden.", true
                        self.SetRedirectAction()
                        return
                    , if self.apiMethod == 'POST' then JSON.stringify(body) else {}
            catch error
                console.log "Beim Versuch Daten zu senden trat ein Fehler auf", error
        return
    
    SetErrorMessage: (errorMessage, hideInputs) ->
        if errorMessage && errorMessage != ""
            @.successActive = false
            @.$el.classList.remove 'add-entry--success'
            @.$errorEl.innerHTML = errorMessage
            @.errorActive = true
            @.$el.classList.add 'add-entry--error'
            if hideInputs
                @.$el.classList.add 'add-entry--hide-inputs'
        else
            @.errorActive = false
            @.$el.classList.remove 'add-entry--error', 'add-entry--hide-inputs'
            @.$errorEl.innerHTML = ""
        return
    
    SetRedirectAction: (topicRedirect) ->
        if @.successRedirect
            if @.$parentOverlay
                if @.$parentOverlay.dataset?.id
                    overlayEl = document.getElementById @.$parentOverlay.dataset.id
                    if overlayEl
                        redirectOnClose = "#{@.successRedirect}"
                        if @.type == "topic"
                            if topicRedirect && topicRedirect != ""
                                redirectOnClose += topicRedirect
                        overlayEl.dispatchEvent new CustomEvent 'overlay-set-redirect-on-close', {
                            bubbles: false,
                            detail: {
                                redirectOnClose: redirectOnClose
                            }
                        }
            else
                if @.successRedirect == "reload"
                    window.location.reload()
                else
                    window.location @.successRedirect
        return
    
    SetSuccessMessage: (successMessage) ->
        if successMessage
            @.errorActive = false
            @.$el.classList.remove 'add-entry--error'
            @.$successEl.innerHTML = successMessage
            @.successActive = true
            @.$el.classList.add 'add-entry--success'
        else
            @.successActive = false
            @.$el.classList.remove 'add-entry--success'
            @.$successEl.innerHTML = ""
        return
    
    Validate: ->
        self = @
        @.valid = true
        errorMessage = "Es wurden nicht alle Pflichtfelder ausgefüllt:<br/>"
        if @.type == 'post' && @.$textInputEl.value == ""
            @.valid = false
            errorMessage += "
                <br/>
                Der Beitragstext darf nicht leer sein
            "
            @.$textEl.dispatchEvent new CustomEvent 'textarea-set-error', {
                bubbles: false
                detail: {
                    error: @.$textInputEl.value == ""
                }
            }
        if @.type == 'topic'
            if @.$topicSubjectInputEl.value == ""
                @.valid = false
                errorMessage += "
                    <br/>
                    Für das Thema muss ein Name angegeben werden
                "
            if @.$textInputEl.value == ""
                @.valid = false
                errorMessage += "
                    <br/>
                    Der Beitragstext darf nicht leer sein
                "
            @.$textEl.dispatchEvent new CustomEvent 'textarea-set-error', {
                bubbles: false
                detail: {
                    error: @.$textInputEl.value == ""
                }
            }
            @.$topicSubjectEl.dispatchEvent new CustomEvent 'input-set-error', {
                bubbles: false
                detail: {
                    error: @.$topicSubjectInputEl.value == ""
                }
            }
        if !@.valid
            @.SetErrorMessage errorMessage
        else
            @.SetErrorMessage false
        return

BindAddEntries = ->
    document.querySelectorAll '.add-entry:not(.add-entry--bound)'
        .forEach (el) ->
            new AddEntry el
            return
    return

window.addEventListener 'bind-components', BindAddEntries